import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { useEsigningRecipients } from 'app/domains/esigning/hooks/useEsigningRecipients';
import { useEsigningSettings } from 'app/domains/esigning/hooks/useEsigningSettings';
import { RecipientItem } from '../../../RecipientItem';
import { RecipientModal } from '../../../RecipientModal';
import { RecipientsAccordion } from '../../../RecipientsAccordion';
import { RecipientActions } from '../RecipientActions';
export function Viewers() {
    const { viewerRecipients } = useEsigningRecipients();
    const { groupMessage } = useEsigningSettings();
    const [showAddPartyModal, setShowAddPartyModal] = useState(false);
    const showModal = () => setShowAddPartyModal(true);
    const hideModal = () => setShowAddPartyModal(false);
    if (viewerRecipients.length === 0) {
        return null;
    }
    return (<Fragment>
      {showAddPartyModal && <RecipientModal onClose={hideModal}/>}
      <RecipientsAccordion hideTooManyItems title={t({
            message: 'Non signing parties',
            comment: 'Label for non signing parties list',
        })} endElement={<Button data-id="add-non-signing-party-button" size="xs" appearance="secondary" onClick={showModal}>
            <Trans comment="Add signing party button label">Add party</Trans>
          </Button>}>
        {viewerRecipients.map((recipient) => (<RecipientItem key={recipient.id} recipient={recipient} groupMessage={groupMessage} endElement={<RecipientActions recipient={recipient}/>}/>))}
      </RecipientsAccordion>
    </Fragment>);
}
